/**
 * <cart-upsell> — the cart drawer's complementary-product row
 * (snippets/cart-drawer-upsell.liquid).
 *
 * Each card is a plain /cart/add form. This turns its submit into the same
 * AJAX add product-form.js performs: post with the drawer's sections, repaint
 * through CartDrawer.renderContents(), and publish cartUpdate so the gift
 * engine (assets/gift-manager.js) reconciles tiers exactly as it does for a
 * product-page add. The repaint re-renders this row too, which is what drops
 * the added product and brings in the next suggestion.
 */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', this.onSubmit.bind(this));
      }

      onSubmit(event) {
        const form = event.target.closest('.cart-upsell__form');
        const cart = this.closest('cart-drawer');
        if (!form || !cart || typeof fetchConfig !== 'function') return;

        event.preventDefault();
        const button = event.submitter || form.querySelector('[type="submit"]');
        if (!button || button.getAttribute('aria-disabled') === 'true') return;
        this.setLoading(button, true);
        this.showError('');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(form);
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        const variantId = formData.get('id');

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'cart-upsell',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.setLoading(button, false);
              this.showError(response.description || response.message);
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-upsell',
              productVariantId: variantId,
              cartData: response,
            });
            // Jump the item list to the top so the shopper sees the product they
            // just added: Shopify puts a new line first. Done BEFORE the repaint
            // because both restore paths in cart-drawer.js would otherwise put
            // the old position back — renderContents() re-applies the scroller's
            // scrollTop read at call time, and its MutationObserver replays
            // lastScrollTop after any later refresh (e.g. the gift engine's).
            const scroller = cart.querySelector('cart-drawer-items');
            if (scroller) scroller.scrollTop = 0;
            cart.lastScrollTop = 0;
            // Replaces this element, so no loading reset is needed.
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.setLoading(button, false);
            this.showError(window.cartStrings?.error);
          });
      }

      setLoading(button, loading) {
        const spinner = button.querySelector('.loading__spinner');
        button.classList.toggle('loading', loading);
        if (loading) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
        spinner?.classList.toggle('hidden', !loading);
      }

      showError(message) {
        const el = this.querySelector('.cart-upsell__error');
        if (!el) return;
        el.textContent = message || '';
        el.hidden = !message;
      }
    }
  );
}
